import { fabric } from "fabric"
import DrawableMixin from "@/signomatic/app/objects/drawable_mixin"

export default DrawableMixin(fabric.Circle)
